// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2IZaV","bigColWidth":"Table_bigColWidth__31ss7","biggerColWidth":"Table_biggerColWidth__3LKGY","row":"Table_row__3GVPp","col":"Table_col__1tF5B"};